module.exports = __webpack_public_path__ + "static/fonts/iconfont.19e799f8.woff";